import {Button, Div, ImageView, Label} from 'components';
import {Ecolors, Icons} from 'constant';
import React from 'react';

const ComCheck = (p: {
  accept: boolean;
  setIsAccept: () => void;
  content: string;
  paddingVertical?: number;
}) => {
  const {accept, setIsAccept, content, paddingVertical} = p;
  return (
    <Div
      flexDirection={'row'}
      width={'100%'}
      paddingVertical={paddingVertical || 24}
      alignItems={'center'}
      justifyContent={'flex-start'}>
      <Button
        widthHeight={25}
        onPress={() => {
          setIsAccept();
        }}
        marginRight={13}
        borderWidth={1}
        alignItems={'center'}
        justifyContent={'center'}
        borderColor={accept ? Ecolors.mainColor : Ecolors.spaceColor}
        borderRadius={25}>
        <ImageView
          key={accept ? 'check' : 'uncheck'}
          source={accept ? Icons.check : Icons.uncheck}
          widthHeight={20}
          tintColor={accept ? Ecolors.mainColor : Ecolors.grayColor}
        />
      </Button>
      <Div flex={1}>
        <Label multilanguage={false}>{content}</Label>
      </Div>
    </Div>
  );
};

export default React.memo(ComCheck);
